module.exports = __webpack_public_path__ + "img/robloxlogo.8159db3c.png";